module.exports = __webpack_public_path__ + "img/certificates-icon-dark.0a08e199.svg";